import React from 'react'
import { useIntl } from 'react-intl'
import { Text } from '@contrast-security-inc/design-system-typography'
import { Dropdown } from '@contrast-security-inc/design-system-inputs'
import { useLibrariesPageContext } from '../../pages'
import { layoutStyles } from './layout-styles'
import { QuickFilter } from './types'

export type LayoutSidebarContentProps = {
  quickFilters: QuickFilter[]
  selectedQuickFilterMap?: QuickFilter
}

export const renderQuickFilter = (
  item: QuickFilter,
  selectedQuickFilter: string
) => (
  <div>
    <Text
      font={
        // Display bold on the selected filter
        selectedQuickFilter?.toLowerCase() === item.name?.toLowerCase()
          ? 'bodyStrong'
          : 'body'
      }
      color="neutral100"
      testId="quick-filter-name"
    >
      {item.name}
    </Text>
    {item.count || item.count === 0 ? (
      <Text font="body" color="neutral70" testId="quick-filter-count">
        {' '}
        ({item.count})
      </Text>
    ) : null}
  </div>
)

export const LayoutSidebarContent = ({
  quickFilters,
  selectedQuickFilterMap
}: React.PropsWithChildren<LayoutSidebarContentProps>) => {
  const { formatMessage } = useIntl()
  const { selectedQuickFilter, setSelectedQuickFilter } =
    useLibrariesPageContext()

  return (
    <div className={layoutStyles.quickViewContainerCss}>
      <Text as="h3" className={layoutStyles.quickViewTitleCss} font="titleH3">
        {formatMessage({ id: 'title_libraries_quickViews' })}
      </Text>
      <Dropdown
        testId="layout-sidebar-content-quick-filters"
        aria-label={formatMessage({ id: 'title_libraries_quickFilter' })}
        itemToID={(item) => item.id}
        label={formatMessage({ id: 'title_libraries_selectQuickFilter' })}
        itemToString={(item) => item.name}
        items={quickFilters}
        customRender={(item: QuickFilter) =>
          renderQuickFilter(item, selectedQuickFilter)
        }
        renderInputValue={(item: QuickFilter) =>
          renderQuickFilter(item, selectedQuickFilter)
        }
        value={{
          id: selectedQuickFilter,
          name:
            selectedQuickFilterMap?.name ||
            formatMessage({ id: 'title_loading' }),
          count: selectedQuickFilterMap?.count
        }}
        onChange={(_evt, value) => setSelectedQuickFilter(value?.id)}
      />
    </div>
  )
}
